// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactFinalForm from "react-final-form";
import * as JotaiAtoms$OrcaPaymentPage from "../../Utilities/JotaiAtoms.bs.js";
import * as PaymentInputField$OrcaPaymentPage from "../PaymentInputField.bs.js";
import * as DynamicFieldsUtils$OrcaPaymentPage from "../../Utilities/DynamicFieldsUtils.bs.js";

function GenericInputField(props) {
  var fieldConfig = props.fieldConfig;
  var fieldRef = React.useRef(null);
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var match$1 = DynamicFieldsUtils$OrcaPaymentPage.resolveFieldTexts(fieldConfig, localeString);
  var autocomplete = fieldConfig.htmlAutocompleteAttribute;
  var validate = DynamicFieldsUtils$OrcaPaymentPage.resolveValidator(fieldConfig, localeString);
  var match$2 = ReactFinalForm.useField(fieldConfig.confirmRequestWritePath, {
        validate: validate
      });
  var meta = match$2.meta;
  var input = match$2.input;
  var value = Core__Option.getOr(input.value, "");
  var showError = (meta.touched || meta.submitFailed) && !meta.active;
  var isValid = showError ? meta.valid : undefined;
  var errorString = showError && meta.invalid ? Core__Option.getOr(meta.error, "") : "";
  return React.createElement(PaymentInputField$OrcaPaymentPage.make, {
              isValid: Caml_option.some(isValid),
              value: value,
              onChange: (function (ev) {
                  input.onChange(ev.target.value);
                }),
              onBlur: (function (_ev) {
                  input.onBlur();
                }),
              errorString: errorString,
              onFocus: (function (_ev) {
                  input.onFocus();
                }),
              fieldName: match$1.label,
              name: DynamicFieldsUtils$OrcaPaymentPage.getFieldTestId(fieldConfig.confirmRequestWritePath),
              maxLength: fieldConfig.maxInputLength,
              placeholder: match$1.placeholder,
              inputRef: fieldRef,
              autocomplete: autocomplete
            });
}

var make = GenericInputField;

export {
  make ,
}
/* jotai Not a pure module */
